import { useState } from "react";
import { X, Zap, ZapOff } from "lucide-react";

const conditions = ["Supérieur à (>)", "Inférieur à (<)", "Égal à (=)", "Supérieur ou égal (≥)", "Inférieur ou égal (≤)", "Différent de (≠)"];

export default function ConditionModal({ conn, onValidate, onClose, initialCondition, initialValeur, initialAction }) {
  const [condition, setCondition] = useState(initialCondition || "Supérieur à (>)");
  const [valeur, setValeur] = useState(initialValeur || "");
  const [action, setAction] = useState(initialAction || "Activer");

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40"
      onMouseDown={e => e.stopPropagation()}>
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-[440px]"
        onMouseDown={e => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="font-bold text-slate-800 text-lg">Configurer la condition</h3>
            <p className="text-sm text-slate-400">Condition + action sur l'actionneur cible</p>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg"><X size={16} /></button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Source (capteur)</label>
            <div className="px-3 py-2.5 border border-blue-300 rounded-xl text-sm font-semibold bg-blue-50 text-slate-700">
              {conn?.fromLabel || "—"}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Cible (actionneur)</label>
            <div className="px-3 py-2.5 border border-orange-300 rounded-xl text-sm font-semibold bg-orange-50 text-slate-700">
              {conn?.toLabel || "—"}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1 block">Condition</label>
            <p className="text-xs text-slate-400 mb-2">Si la valeur du capteur...</p>
            <div className="flex gap-2">
              <select value={condition} onChange={e => setCondition(e.target.value)}
                className="flex-1 px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
                {conditions.map(c => <option key={c}>{c}</option>)}
              </select>
              <input value={valeur} onChange={e => setValeur(e.target.value)}
                placeholder="Valeur (ex: 30)"
                className="w-32 px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Alors : action sur l'actionneur</label>
            <div className="grid grid-cols-2 gap-2">
              <button
                type="button"
                onClick={() => setAction("Activer")}
                className={`flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold border-2 transition-all ${
                  action === "Activer"
                    ? "border-green-500 bg-green-50 text-green-700"
                    : "border-gray-200 bg-gray-50 text-slate-500 hover:border-gray-300"
                }`}
              >
                <Zap size={16} /> Activer
              </button>
              <button
                type="button"
                onClick={() => setAction("Désactiver")}
                className={`flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold border-2 transition-all ${
                  action === "Désactiver"
                    ? "border-red-500 bg-red-50 text-red-700"
                    : "border-gray-200 bg-gray-50 text-slate-500 hover:border-gray-300"
                }`}
              >
                <ZapOff size={16} /> Désactiver
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose}
            className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm text-slate-600 hover:bg-gray-50">
            Annuler
          </button>
          <button
            disabled={!valeur.trim()}
            onClick={() => onValidate({ condition, valeur, action })}
            className="px-5 py-2.5 bg-slate-900 text-white rounded-xl text-sm font-medium hover:bg-slate-800 disabled:opacity-40 disabled:cursor-not-allowed">
            Valider
          </button>
        </div>
      </div>
    </div>
  );
}